export default __webpack_public_path__ + "c2597ec69ff48f674689bb20d3866f76.png";